import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import LoginModal from './LoginModal';

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          backgroundColor: '#f5f5f5',
        }}
      >
        <CircularProgress sx={{ color: '#600002' }} size={60} />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <LoginModal open={true} />;
  }

  return children;
}

export default ProtectedRoute;

